module.exports = __webpack_public_path__ + "media/components/app-store/static/s6-1c46e01280b369b2bf39b40ac3cfcc20.png";